import { UniversalAddress } from '../universalAddress.js';
export const universalAddressItem = {
    binary: "bytes",
    size: 32,
    custom: {
        to: (val) => new UniversalAddress(val),
        from: (val) => val.toUint8Array(),
    },
};
//# sourceMappingURL=universalAddress.js.map